<div
  class="tabs tabs--thin tabs--in-box corporate-card-tabs tabs-with-state-tab"
>
  <div class="nav" id="nav-tab" role="tablist">
    <a
      class="nav-item nav-link"
      data-toggle="tab"
      [routerLink]="['/personal/batch/batches']"
      routerLinkActive="active"
      role="tab"
    >
      {{ 'BATCH_MAILING.BATCHES_TAB.TITLE' | translate }}
    </a>
    <a
      class="nav-item nav-link"
      data-toggle="tab"
      [routerLink]="['/personal/batch/blanks']"
      routerLinkActive="active"
      role="tab"
    >
      {{ 'BATCH_MAILING.BLANKS_TAB.TITLE' | translate }}
    </a>
    <a
      class="nav-item nav-link"
      data-toggle="tab"
      [routerLink]="['/personal/batch/invoices']"
      routerLinkActive="active"
      role="tab"
    >
      {{ 'BATCH_MAILING.RECEIPTS_TAB.TITLE' | translate }}
    </a>
    <a
      class="nav-item nav-link"
      data-toggle="tab"
      [routerLink]="['/personal/batch/addresses']"
      routerLinkActive="active"
      role="tab"
    >
      {{ 'BATCH_MAILING.RECIPIENTS_TAB.TITLE' | translate }}
    </a>
  </div>
  <div class="tabs__line" aria-hidden="true"></div>
</div>
